module.exports = __webpack_public_path__ + "video/600_HC_2023_The_Anatomy_of_a_Phishing_Email.94b8a2de.vtt";